import type { AxiosError } from 'axios'
import { useCallback, useState } from 'react'

import { useToast } from '@/hooks'
import { servicoBase } from '@/services/servico-base'

import type { MarcarTodasAsNotificacoesComoVisualizadasResposta } from './tipos'

export function useMarcarTodasAsNotificacoesComoVisualizadas(): MarcarTodasAsNotificacoesComoVisualizadasResposta {
  const toast = useToast()

  const [loading, setLoading] = useState<boolean>(false)
  const [erro, setErro] = useState<AxiosError | null>(null)

  const marcarTodasAsNotificacoesComoVisualizadas =
    useCallback(async (): Promise<boolean> => {
      try {
        setLoading(true)

        await servicoBase.post('/v1/notificacoes/visualizar-todas')

        return true
      } catch (error: any) {
        setErro(error as AxiosError)

        toast.erro('Aconteceu um erro', {
          descricao: `Não foi possível marcar as notificações como vistas: ${error?.response?.data?.detail ?? 'Erro desconhecido.'}`,
        })
      } finally {
        setLoading(false)
      }

      return false
    }, [])

  return [marcarTodasAsNotificacoesComoVisualizadas, { loading, erro }]
}
